import { render } from "./turn.vue?vue&type=template&id=df2c8710&scoped=true"
import script from "./turn.vue?vue&type=script&lang=js"
export * from "./turn.vue?vue&type=script&lang=js"

import "./turn.vue?vue&type=style&index=0&id=df2c8710&scoped=true&lang=css"
import "./turn.vue?vue&type=style&index=1&id=df2c8710&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2c8710"]])

export default __exports__